export { default } from 'common/models/cover';
